import { Link } from "react-router-dom";
import { Lock, ArrowRight, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Home() {
  const { user, ready } = useAuth();
  const authed = ready && user && user !== false;
  return (
    <div className="min-h-screen bg-navy-950 text-white flex flex-col" data-testid="locked-gate">
      <header className="h-20 px-8 flex items-center border-b border-gold-500/15">
        <Logo variant="light" />
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-lg w-full text-center">
          <div className="mx-auto h-16 w-16 rounded-sm border border-gold-500/40 bg-gold-500/10 flex items-center justify-center mb-8">
            <Lock className="h-7 w-7 text-gold-400" />
          </div>
          <span className="font-mono uppercase tracking-[0.25em] text-[0.6rem] text-gold-500/70">
            Managing Disaster Australia
          </span>
          <h1 className="font-heading font-light text-4xl sm:text-5xl tracking-tight mt-4">
            The MDAu Office
          </h1>
          <p className="text-white/55 font-light mt-5 leading-relaxed">
            This is a private system. Access is restricted to authorised
            Managing Disaster Australia personnel only.
          </p>
          <div className="mt-9">
            {authed ? (
              <Link
                to="/dashboard"
                data-testid="gate-enter-office-btn"
                className="inline-flex items-center gap-2 bg-gold-500 text-navy-950 font-semibold px-7 py-3.5 rounded-sm hover:bg-gold-400 transition-colors"
              >
                Enter the MDAu Office <ArrowRight className="h-4 w-4" />
              </Link>
            ) : (
              <Link
                to="/login"
                data-testid="gate-signin-btn"
                className="inline-flex items-center gap-2 bg-gold-500 text-navy-950 font-semibold px-7 py-3.5 rounded-sm hover:bg-gold-400 transition-colors"
              >
                Sign in <ArrowRight className="h-4 w-4" />
              </Link>
            )}
          </div>
          <div className="mt-10 space-y-3">
            <span className="font-mono uppercase tracking-[0.25em] text-[0.55rem] text-gold-500/60 block">
              FieldClaim field app — coming soon
            </span>
            <div className="flex items-center justify-center gap-3" data-testid="store-badges">
              <img src="/badges/app-store-badge.svg" alt="Download on the App Store — coming soon" className="h-10 opacity-80" data-testid="badge-appstore" />
              <img src="/badges/google-play-badge.png" alt="Get it on Google Play — coming soon" className="h-[3.7rem] -my-2 opacity-80" data-testid="badge-googleplay" />
            </div>
          </div>
          <div className="mt-8 inline-flex items-center gap-2 text-white/35 text-xs font-light">
            <ShieldCheck className="h-3.5 w-3.5 text-gold-500/60" />
            Authorised access only · all activity is logged
          </div>
        </div>
      </main>

      <footer className="h-16 px-8 flex items-center justify-center gap-4 border-t border-gold-500/10">
        <span className="font-mono uppercase tracking-[0.2em] text-[0.55rem] text-white/30">
          © Managing Disaster Australia · managingdisaster.com.au
        </span>
        <Link to="/privacy" data-testid="footer-privacy-link" className="font-mono uppercase tracking-[0.2em] text-[0.55rem] text-white/30 hover:text-gold-400 transition-colors">
          Privacy
        </Link>
      </footer>
    </div>
  );
}
